import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import TexturesSlice from "./slices/TexturesSlice";
import HistorySlice from './slices/HistorySlice';
import ApplicationSlice from './slices/ApplicationSlice';
import AssetsSlice from "./slices/AssetsSlice";
import FilesSlice from "./slices/FilesSlice";
import MaterialsSlice from "./slices/MaterialsSlice";
import ScenarioSlice from './slices/ScenarioSlice';
import UISlice from "./slices/UISlice";
import ChecklistSlice from './slices/ChecklistSlice';
import RevisionSlice from './slices/RevisionSlice';
import WorkspaceSlice from "./slices/WorkspaceSlice";
import UserSlice from "./slices/UserSlice";
import TimelineSlice from "./slices/TimelineSlice";
import IOTSlice from './slices/IOTSlice';
import ChatGPTSlice from './slices/ChatGPTSlice';
import AttachmentsSlice from "./slices/AttachmentsSlice";
import PartsCatalogSlice from "./slices/PartsCatalogSlice";
import VisageSlice from "./slices/VisageSlice";
import WorklinkSlice from "./slices/Worklink";
import PreferencesSlice from "./slices/PreferencesSlice";

export const StoreActions = {
	application: { ...ApplicationSlice.actions },
	user: { ...UserSlice.actions },
	history: { ...HistorySlice.actions },
	textures: { ...TexturesSlice.actions },
	assets: { ...AssetsSlice.actions },
	files: { ...FilesSlice.actions },
	material: { ...MaterialsSlice.actions },
	scenario: { ...ScenarioSlice.actions },
	ui: { ...UISlice.actions },
	checklist: { ...ChecklistSlice.actions },
	revision: { ...RevisionSlice.actions },
	workspace: { ...WorkspaceSlice.actions },
	timeline: { ...TimelineSlice.actions },
	iot: { ...IOTSlice.actions },
	attachments: { ...AttachmentsSlice.actions },
	partsCatalog: { ...PartsCatalogSlice.actions },
	visage: { ...VisageSlice.actions },
	chatGPT: { ...ChatGPTSlice.actions },
	worklink: { ...WorklinkSlice.actions },
	preferences: { ...PreferencesSlice.actions },
};

export const reducer = combineReducers({
	applicationModule: ApplicationSlice.reducer,
	userModule: UserSlice.reducer,
	historyModule: HistorySlice.reducer,
	assetModule: AssetsSlice.reducer,
	texturesModule: TexturesSlice.reducer,
	fileModule: FilesSlice.reducer,
	materialsModule: MaterialsSlice.reducer,
	scenarioModule: ScenarioSlice.reducer,
	uiModule: UISlice.reducer,
	checklistModule: ChecklistSlice.reducer,
	revisionModule: RevisionSlice.reducer,
	workspaceModule: WorkspaceSlice.reducer,
	timelineModule: TimelineSlice.reducer,
	iotModule: IOTSlice.reducer,
	chatGPTModule: ChatGPTSlice.reducer,
	attachmentsModule: AttachmentsSlice.reducer,
	partsCatalogModule: PartsCatalogSlice.reducer,
	visageModule: VisageSlice.reducer,
	worklinkModule: WorklinkSlice.reducer,
	preferencesModule: PreferencesSlice.reducer,
});

const store = configureStore({
	reducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({
		serializableCheck: true,
		immutableCheck: true
	}),
});

export type RootState = ReturnType<typeof reducer>;
export type AppDispatch = typeof store.dispatch;
export default store;
